import { Controller } from "stimulus";

export default class extends Controller {
  static values = {
    prompt: Object
  };

  connect() {
    const prompt = this.promptValue;
    if (prompt && prompt.enterUrl) {
      this.cleanConfirmParam();
      this.openConfirm(prompt);
    }
  }

  cleanConfirmParam() {
    const url = new URL(window.location.href);
    if (!url.searchParams.has("confirm_trial")) return;

    url.searchParams.delete("confirm_trial");
    window.history.replaceState({}, "", url.toString());
  }

  confirmEnter(event) {
    event.preventDefault();
    const row = event.currentTarget;
    this.openConfirm({
      enterUrl: row.dataset.enterUrl,
      trialName: row.dataset.trialName,
      trialNct: row.dataset.trialNct
    });
  }

  openConfirm({ enterUrl, trialName, trialNct }) {
    if (!enterUrl) return;

    const label = trialNct || "this assessment";
    const title = trialName || "Untitled assessment";

    Swal.fire({
      title: `Are you sure you want to view <b>${this.escapeHtml(label)}</b> assessment?`,
      html: `<span class="text-sm text-gray-600">${this.escapeHtml(title)}</span>`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      cancelButtonColor: "#d33",
      allowOutsideClick: false
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.href = enterUrl;
      }
    });
  }

  escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }
}
